export { View as KPKRequisites } from './view'
